import { useEffect, useState } from "react";
import { Plus, Pencil } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PageHeader } from "@/layouts/AdminLayout";
import { api } from "@/lib/api";
import { money } from "@/lib/technicians";
import { CATS, ProductDialog } from "@/components/catalog/ProductDialog";

const compText = (p) => p.components.map((c) => `${c.quantity} × ${c.label}: ${c.allowed_models.join(" / ")}`).join(" · ");

export default function CommercialCatalog() {
  const [rows, setRows] = useState([]);
  const [dlg, setDlg] = useState(null);
  const load = () => api.get("/gps-plans", { params: { include_inactive: true } }).then((r) => setRows(r.data));
  useEffect(() => { load(); }, []);
  return (
    <div className="space-y-6" data-testid="commercial-catalog-page">
      <PageHeader eyebrow="Comercial" title="Catálogo comercial">
        <Button onClick={() => setDlg({})} data-testid="product-new-button"><Plus className="mr-1 h-4 w-4" />Nuevo producto</Button>
      </PageHeader>
      {Object.entries(CATS).map(([cat, label]) => {
        const list = rows.filter((p) => (p.category || "plan_gps") === cat);
        return (
          <section key={cat} className="space-y-2" data-testid={`products-${cat}`}>
            <h2 className="text-sm font-medium text-muted-foreground">{label} ({list.length})</h2>
            {list.map((p) => (
              <div key={p.id} className="flex items-start justify-between gap-3 rounded-lg border border-border p-3" data-testid={`product-row-${p.code}`}>
                <div className="min-w-0 space-y-0.5">
                  <div className="text-sm font-medium">{p.name} <span className="text-xs text-muted-foreground">· {p.code} · v{p.version}{!p.active && " · Inactivo"}</span></div>
                  <div className="text-xs text-muted-foreground">{compText(p)}</div>
                  {(p.price != null || p.warranty_months != null) && <div className="text-xs text-muted-foreground">{p.price != null && `Precio ${money(p.price, "MXN")}`}{p.price != null && p.warranty_months != null && " · "}{p.warranty_months != null && `Garantía ${p.warranty_months} meses`}</div>}
                </div>
                <Button size="icon" variant="ghost" onClick={() => setDlg(p)} data-testid={`product-edit-${p.code}`}><Pencil className="h-4 w-4" /></Button>
              </div>
            ))}
          </section>
        );
      })}
      {dlg && <ProductDialog product={dlg} onClose={() => setDlg(null)} onSaved={() => { setDlg(null); load(); }} />}
    </div>
  );
}
